import React from "react";
import { AccessTime, Star, CalendarMonth, Warning } from "@mui/icons-material";
import { getAvailabilityBgColor } from "../../../../../helpers/helpers";
import { getAvailabilityBorderColor } from "../../../../../helpers/helpers";
import { getAvailabilityTextColor } from "../../../../../helpers/helpers";
import { getAvailabilityIconColor } from "../../../../../helpers/helpers";

const getStatusIcon = (availability) => {
  if (!availability) return AccessTime;
  if (availability === "All Day") return AccessTime;
  if (availability === "Unavailable") return Warning;
  if (availability === "No Availability Set") return AccessTime;
  return AccessTime;
};

const ModalAvailabilityCard = ({
  title,
  availability,
  availability2,
  preferences,
  inEffect,
  icon: Icon
}) => {
  const StatusIcon = getStatusIcon(availability);

  return (
    <div>
      <div className="bg-slate-50 border border-slate-200 rounded-xl p-4">
        <div className="flex flex-row items-center text-gray-700 mb-3">
          <Icon style={{ fontSize: "18px" }} />
          <span className="ml-2 text-sm font-medium text-gray-700">
            {title}
          </span>
        </div>
        <div className={`rounded-xl border p-3 ${getAvailabilityBgColor(availability)} ${getAvailabilityBorderColor(availability)}`}>
          <div className="flex flex-row items-center space-x-2.5">
            <StatusIcon
              style={{ color: getAvailabilityIconColor(availability), fontSize: 16 }}
            />
            <span className={`font-medium ${getAvailabilityTextColor(availability)}`}>
              {availability}
            </span>
          </div>

          {availability2 && (
            <div className="flex flex-row items-center space-x-2.5 mt-2">
              <AccessTime
                style={{ color: getAvailabilityIconColor(availability2), fontSize: 16 }}
              />
              <span className={`font-medium ${getAvailabilityTextColor(availability2)}`}>
                {availability2}
              </span>
            </div>
          )}

          {preferences && preferences !== "No Preferences Set" && (
            <div className="flex flex-row items-center space-x-2.5 mt-2">
              <Star
                style={{ color: getAvailabilityIconColor(availability), fontSize: 16 }}
              />
              <span className={`${getAvailabilityTextColor(availability)}`}>
                {preferences}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalAvailabilityCard;
